
<div class="containerFooter">
  <button *ngIf="leftButton" buttonstyle="leftButton" (click)="leftButtonAction()" [ngClass]="leftButtonComputedStyling">
    <p>{{ leftButton.text }}</p>
  </button>
  <button *ngIf="rightButton" buttonstyle="rightButton" (click)="rightButtonAction()" [ngClass]="rightButtonComputedStyling">
    <p>{{ rightButton.text }}</p>
  </button>
</div>
